var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publications"},[_c('h3',{staticClass:"title md-title md-title--mobile-big"},[_vm._v("Полезные публикации")]),_c('div',{staticClass:"cards line-regular line_mobile-large"},_vm._l((_vm.publications),function(el){return _c('Publication',{key:el.id,attrs:{"data":el}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }